import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { IoMenu, IoClose } from "react-icons/io5";
import { FaFacebook, FaInstagram } from "react-icons/fa";

// IKONY – MOBIL MENU
import { AiFillHome, AiOutlinePhone } from "react-icons/ai";
import { FaRegNewspaper, FaBuilding, FaBed, FaImages, FaChevronRight, FaChevronDown, FaCalendarCheck, FaHotTub } from "react-icons/fa";
import { MdRestaurantMenu } from "react-icons/md";
import { GiForkKnifeSpoon, GiDiamondRing } from "react-icons/gi";
import DenniNabidkaModal from "../denni_nabidka/denni-nabidka-modal.tsx";

const Navbar: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [denniOpen, setDenniOpen] = useState(false);
  const [ubytOpen, setUbytOpen] = useState(false);

  // ===== DESKTOP STICKY LOGIC =====
  const [isSticky, setIsSticky] = useState(false);
  const desktopNavRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onScroll = () => {
      const triggerPoint = window.innerHeight * 0.05;

      if (window.scrollY > triggerPoint) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* ======================================================
         MOBILE HEADER – BEZE ZMĚNY
      ====================================================== */}
      <div className="lg:hidden sticky top-0 left-0 w-screen z-50 bg-[#f5f5f5]">
        <div className="border-t-[5px] border-b-[5px] border-[#30437A]">
          <div className="flex items-center justify-between px-5 py-[18px] font-serif text-[#2d2a7a] bg-[#f5f5f5]">
            <div>
              <h1 className="text-[22px] font-bold leading-tight">
                Hospůdka pod Rablinů
              </h1>
              <p className="text-sm leading-snug">
                Ta pravá chuť Valašska
              </p>
            </div>

            <button
              className="text-4xl"
              onClick={() => setMobileOpen(true)}
              aria-label="Otevřít menu"
            >
              <IoMenu />
            </button>
          </div>
        </div>
      </div>

      {/* ======================================================
         MOBILE MENU OVERLAY
      ====================================================== */}
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-[999] bg-[#30427A] overflow-y-auto">
          <div className="min-h-full box-border px-5 pt-6 pb-7 flex flex-col">
            {/* horní lišta */}
            <div className="flex items-center justify-between mb-6">
              <span className="text-[#dfe4f5] text-xs tracking-[0.1em] uppercase font-medium">
                Hospůdka pod Rablinů
              </span>
              <button
                className="text-[#aeb9dc] text-3xl leading-none flex"
                onClick={() => setMobileOpen(false)}
                aria-label="Zavřít menu"
              >
                <IoClose />
              </button>
            </div>

            {/* navigace */}
            <nav className="flex flex-col gap-1">
              {/* zvýrazněná položka */}
              <button
                type="button"
                onClick={() => {
                  setMobileOpen(false);
                  setDenniOpen(true);
                }}
                className="flex items-center gap-[14px] w-full px-[10px] py-3 rounded-xl text-left bg-[#f2c17a]/[0.14] border border-[#f2c17a]/40"
              >
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-[#f2c17a] text-[#30427A] flex items-center justify-center text-[19px]">
                  <GiForkKnifeSpoon />
                </span>
                <span className="flex flex-col min-w-0">
                  <span className="font-serif text-[19px] leading-tight text-[#f6d9a9]">Denní nabídka</span>
                  <span className="text-[12px] leading-snug text-[#9fb0dc] mt-0.5">Dnešní polévka a hlavní jídla</span>
                </span>
                <FaChevronRight className="ml-auto text-[#8ea0d6] text-base flex-shrink-0" />
              </button>

              <Link to="/" onClick={() => setMobileOpen(false)} className="flex items-center gap-[14px] px-[10px] py-3 rounded-xl active:bg-white/[0.06]">
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><AiFillHome /></span>
                <span className="font-serif text-[19px] leading-tight text-white">Domů</span>
              </Link>

              <Link to="/aktuality" onClick={() => setMobileOpen(false)} className="flex items-center gap-[14px] px-[10px] py-3 rounded-xl active:bg-white/[0.06]">
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><FaRegNewspaper /></span>
                <span className="font-serif text-[19px] leading-tight text-white">Aktuality</span>
              </Link>

              <Link to="/jidelni-listek" onClick={() => setMobileOpen(false)} className="flex items-center gap-[14px] px-[10px] py-3 rounded-xl active:bg-white/[0.06]">
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><MdRestaurantMenu /></span>
                <span className="flex flex-col min-w-0">
                  <span className="font-serif text-[19px] leading-tight text-white">Jídelní lístek</span>
                  <span className="text-[12px] leading-snug text-[#9fb0dc] mt-0.5">Stálá nabídka</span>
                </span>
              </Link>

              <Link to="/svatby" onClick={() => setMobileOpen(false)} className="flex items-center gap-[14px] px-[10px] py-3 rounded-xl active:bg-white/[0.06]">
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><GiDiamondRing /></span>
                <span className="font-serif text-[19px] leading-tight text-white">Svatby</span>
              </Link>

              <Link to="/firmy" onClick={() => setMobileOpen(false)} className="flex items-center gap-[14px] px-[10px] py-3 rounded-xl active:bg-white/[0.06]">
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><FaBuilding /></span>
                <span className="font-serif text-[19px] leading-tight text-white">Firmy</span>
              </Link>

              {/* Ubytování s podmenu */}
              <div>
                <button
                  type="button"
                  onClick={() => setUbytOpen((o) => !o)}
                  className="flex items-center gap-[14px] w-full px-[10px] py-3 rounded-xl active:bg-white/[0.06]"
                >
                  <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><FaBed /></span>
                  <span className="font-serif text-[19px] leading-tight text-white">Ubytování</span>
                  <FaChevronDown className={`ml-auto text-[#8ea0d6] text-[15px] flex-shrink-0 transition-transform duration-300 ${ubytOpen ? "rotate-180" : ""}`} />
                </button>
                {ubytOpen && (
                  <div className="flex flex-col gap-[10px] pl-[60px] pt-1 pb-2">
                    <Link to="/ubytovani" onClick={() => setMobileOpen(false)} className="text-[#c3cdea] text-sm active:text-white">Pokoje</Link>
                    <Link to="/wellness" onClick={() => setMobileOpen(false)} className="text-[#c3cdea] text-sm active:text-white">Wellness</Link>
                  </div>
                )}
              </div>

              <Link to="/wellness" onClick={() => setMobileOpen(false)} className="flex items-center gap-[14px] px-[10px] py-3 rounded-xl active:bg-white/[0.06]">
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><FaHotTub /></span>
                <span className="flex flex-col min-w-0">
                  <span className="font-serif text-[19px] leading-tight text-white">Wellness</span>
                  <span className="text-[12px] leading-snug text-[#9fb0dc] mt-0.5">Vířivky, sauna a odpočívárna</span>
                </span>
              </Link>

              <Link to="/galerie" onClick={() => setMobileOpen(false)} className="flex items-center gap-[14px] px-[10px] py-3 rounded-xl active:bg-white/[0.06]">
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><FaImages /></span>
                <span className="font-serif text-[19px] leading-tight text-white">Galerie</span>
              </Link>

              <Link to="/kontakt" onClick={() => setMobileOpen(false)} className="flex items-center gap-[14px] px-[10px] py-3 rounded-xl active:bg-white/[0.06]">
                <span className="w-9 h-9 flex-shrink-0 rounded-[10px] bg-white/10 text-[#cdd6f2] flex items-center justify-center text-[19px]"><AiOutlinePhone /></span>
                <span className="font-serif text-[19px] leading-tight text-white">Kontakt</span>
              </Link>
            </nav>

            {/* patička s CTA */}
            <div className="mt-auto pt-[18px] flex gap-[10px] border-t border-white/15">
              <Link to="/rezervace" onClick={() => setMobileOpen(false)} className="flex-1 flex items-center justify-center gap-2 py-[13px] rounded-xl text-[15px] font-medium bg-[#f2c17a] text-[#30427A]">
                <FaCalendarCheck /> Rezervovat
              </Link>
              <Link to="/kontakt" onClick={() => setMobileOpen(false)} className="basis-[34%] flex items-center justify-center py-[13px] rounded-xl text-[15px] font-medium bg-transparent text-[#dfe4f5] border border-white/[0.28]">
                Mapa
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* ======================================================
         DESKTOP HEADER (NÁZEV + KONTAKTY)
      ====================================================== */}
      <div className="hidden lg:flex bg-[#f5e6c8] text-[#3b1f0f] font-serif px-12 py-6 relative z-40">
        <div className="flex-1">
          <h1 className="text-3xl font-bold">Hospůdka pod Rablinů</h1>
          <p className="text-sm font-semibold">Ta pravá chuť Valašska</p>
        </div>

        <div className="text-right space-y-1">
          <div className="flex items-center justify-end gap-3 text-2xl font-bold">
            +420 608 608 101 <FaInstagram />
          </div>
          <div className="flex items-center justify-end gap-3 text-sm">
            +420 736 253 640 – ubytování <FaFacebook />
          </div>
        </div>
      </div>

      {/* ======================================================
         DESKTOP NAVBAR – ANIMOVANÝ PŘECHOD
      ====================================================== */}
      <div
        ref={desktopNavRef}
        className={`hidden lg:block w-full bg-[#60260f] text-white font-serif z-50
          transition-all duration-300 ease-out
          ${isSticky ? "fixed top-0 left-0 shadow-xl translate-y-0 opacity-100" : "relative translate-y-0 opacity-100"}
        `}
      >
        <div className="max-w-7xl mx-auto px-6 h-[80px] flex items-center justify-center">
          {/* flex-none na položkách je nutnost: globální `* { overflow-x: hidden }`
              by zmenšeným flex položkám ořízlo poslední písmeno */}
          <ul className="flex gap-7 xl:gap-11 2xl:gap-14 text-lg xl:text-xl font-bold tracking-wide whitespace-nowrap [&>li]:flex-none">
            <li><Link to="/">DOMŮ</Link></li>
            <li><Link to="/aktuality">AKTUALITY</Link></li>
            <li><Link to="/jidelni-listek">MENU</Link></li>
            <li><Link to="/svatby">SVATBY</Link></li>
            <li><Link to="/firmy">FIRMY</Link></li>
            <li><Link to="/ubytovani">UBYTOVÁNÍ</Link></li>
            <li><Link to="/wellness">WELLNESS</Link></li>
            <li><Link to="/galerie">GALERIE</Link></li>
            <li><Link to="/kontakt">KONTAKT</Link></li>
          </ul>
        </div>
      </div>

      {/* Spacer jen když je navbar fixed */}
      {isSticky && <div className="hidden lg:block h-[80px]" />}

      <DenniNabidkaModal open={denniOpen} onClose={() => setDenniOpen(false)} />
    </>
  );
};

export default Navbar;
